import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  MarkAreaComponent,
  MarkLineComponent,
  TitleComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { NgxEchartsDirective, NgxEchartsModule, provideEchartsCore } from 'ngx-echarts';

import { DrilldownChartNoDataAvailableModule } from '../drilldown-chart-no-data-available/drilldown-chart-no-data-available.module';
import { ToggleModule } from '../toggle/toggle.module';
import { TrendChartComponent } from './trend-chart.component';
import { TrendChartLegendComponent } from './trend-chart-legend/trend-chart-legend.component';

echarts.use([
  CanvasRenderer,
  BarChart,
  PieChart,
  LineChart,
  GridComponent,
  TitleComponent,
  MarkLineComponent,
  MarkAreaComponent,
  LegendComponent
]);

@NgModule({
  declarations: [TrendChartComponent, TrendChartLegendComponent],
  exports: [TrendChartComponent, TrendChartLegendComponent],
  imports: [
    CommonModule,
    NgxEchartsDirective,
    NgxEchartsModule.forRoot({ echarts }),
    DrilldownChartNoDataAvailableModule,
    ToggleModule,
    MatIconModule
  ],
  providers: [provideEchartsCore({ echarts })],

  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TrendChartModule {}
